"use client";
import React from "react";
import Logo from "./Logo";
import NavigationLinks from "./NavigationLinks";
import CopyrightSection from "./CopyrightSection";

function Footer({isRegisterPage}) {
  return (
    <footer className="position-relative w-100" style={{ backgroundColor: "#0c4a6e", minHeight: "226px" }}>
      <style jsx>{`
        .footer-background {
          background-color: #0c4a6e;
        }
        .footer-content {
          top: 2.25rem;
          left: 50%;
          transform: translateX(-50%);
          height: 153px;
          width: 848px;
          max-width: 848px;
        }
        @media (max-width: 768px) {
          .footer-content {
            max-width: 600px;
            width: 90%;
          }
        }
        @media (max-width: 576px) {
          .footer-container {
            height: auto;
            min-height: 300px;
            padding: 2rem 0;
          }
          .footer-content {
            top: 2rem;
            gap: 2rem;
            height: auto;
            width: 95%;
            text-align: center;
          }
        }
      `}</style>
      <div className="footer-container position-relative w-100 footer-background" >
        <div className="position-absolute top-0 start-0 w-100 h-100 footer-background"></div>
        <div className="footer-content position-absolute d-flex flex-column gap-3 align-items-center justify-content-center">
          <Logo />
          <NavigationLinks isRegisterPage={isRegisterPage}/>
          <CopyrightSection />
        </div>
      </div>
    </footer>
  );
}

export default Footer;
